import { Action } from "redux";

export const GEOCALC_GEOMETRY_REMOVED = "GEOCALC_GEOMETRY_REMOVED";

interface GeoCalcGeometryRemovedAction extends Action {
    geoCalculation: number;
}

export const geoCalcGeometryRemovedAction = (geoCalculationId: number): GeoCalcGeometryRemovedAction => {
    return {
        type: GEOCALC_GEOMETRY_REMOVED,
        geoCalculation: geoCalculationId,
    };
};
